/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Execute_Output7Inputs */

const en_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewed service`)
};

const ar_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خدمة مراجعة`)
};

const bn_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিভিউড সার্ভিস`)
};

const de_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerteter Service`)
};

const es_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicio revisado`)
};

const fr_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service examiné`)
};

const pt_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviço revisado`)
};

const zh_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已审核的服务`)
};

const tr_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İncelenen hizmet`)
};

const ru_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверенная услуга`)
};

const pl_svc_backend_development_execute_output7 = /** @type {(inputs: Svc_Backend_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzowana usługa`)
};

/**
* | output |
* | --- |
* | "Reviewed service" |
*
* @param {Svc_Backend_Development_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_execute_output7 = /** @type {((inputs?: Svc_Backend_Development_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_execute_output7(inputs)
	if (locale === "bn") return bn_svc_backend_development_execute_output7(inputs)
	if (locale === "de") return de_svc_backend_development_execute_output7(inputs)
	if (locale === "es") return es_svc_backend_development_execute_output7(inputs)
	if (locale === "fr") return fr_svc_backend_development_execute_output7(inputs)
	if (locale === "pt") return pt_svc_backend_development_execute_output7(inputs)
	if (locale === "zh") return zh_svc_backend_development_execute_output7(inputs)
	if (locale === "tr") return tr_svc_backend_development_execute_output7(inputs)
	if (locale === "ru") return ru_svc_backend_development_execute_output7(inputs)
	if (locale === "pl") return pl_svc_backend_development_execute_output7(inputs)
	return en_svc_backend_development_execute_output7(inputs)
});
export { svc_backend_development_execute_output7 as "svc_backend-development_EXECUTE_output" }